export enum ByteUnitAbbrevation {
    Byte = 'B', 
    Kilobyte = 'KB', 
    Megabyte = 'MB',
    Gigabyte =  'GB',
}
